import Vue from 'vue'

import { Breadcrumb, BreadcrumbItem, Form, FormItem, Select, Option, RadioGroup, Radio, Checkbox, Row, Col, Pagination, Loading } from "element-ui";

Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Row)
Vue.use(Col)
Vue.use(Pagination)
Vue.use(Loading.directive)